export default {
  attachments: [],
  data: {},
  pending: [],
  paymentAssets: {
    amount: null,
    paymentId: null,
    memo: null,
  },
};
